import { axiosInstance } from "../../../../Services";
import { MMH_PRODUCTS_BASE_PATH, USE_MOCK } from "./config";
import { mockUpdateProduct } from "../mock/mockApi";
import { buildFormData } from "./buildFormData";

// UPDATE — POST /completedproject/update/:id
//
// Deliberately a POST, not a PUT: PHP never populates $_FILES on a real PUT,
// so an update carrying new images cannot travel that way.
export const UpdateMMHProduct = async (id, payload) => {
  if (USE_MOCK) {
    return mockUpdateProduct(id, payload);
  }
  return axiosInstance.post(`${MMH_PRODUCTS_BASE_PATH}/update/${id}`, buildFormData(payload), {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default UpdateMMHProduct;
